type TComplexPassword = {
  lowerCase?: number,
  upperCase?: number,
  numeric?: number,
  symbol?: number,
}

export const complexPassword  = (params: TComplexPassword) => (value: any, helpers: any) => {
  const lowerCaseCount = value.match(/[a-z]/g)?.length ?? 0;
  const upperCaseCount = value.match(/[A-Z]/g)?.length ?? 0;
  const numericCount = value.match(/[0-9]/g)?.length ?? 0;
  // eslint-disable-next-line
  const symbolCount = value.match(/[\~\!\@\#\$\%\^\&\*\(\)\-\_\=\+\[\]\{\}\|]/g)?.length ?? 0;

  if (params.lowerCase && lowerCaseCount < params.lowerCase) {
    return helpers.error("string.lowerCase");
  }

  if (params.upperCase && upperCaseCount < params.upperCase) {
    return helpers.error("string.upperCase");
  }

  if (params.numeric && numericCount < params.numeric) {
    return helpers.error("string.numeric");
  }

  if (params.symbol && symbolCount < params.symbol) {
    return helpers.error("string.symbol");
  }

  return value;
}
